import { render, staticRenderFns } from "./AdminBadge.vue?vue&type=template&id=3f6270f9&scoped=true&"
import script from "./AdminBadge.vue?vue&type=script&lang=ts&"
export * from "./AdminBadge.vue?vue&type=script&lang=ts&"
import style0 from "./AdminBadge.vue?vue&type=style&index=0&id=3f6270f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6270f9",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
